import { render, staticRenderFns } from "./_workFloStatusDate.vue?vue&type=template&id=328c3cf5&scoped=true&"
import script from "./_workFloStatusDate.vue?vue&type=script&lang=js&"
export * from "./_workFloStatusDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328c3cf5",
  null
  
)

export default component.exports